import { State } from './interfaces';
import {
  StoreAction,
  SET_BASIC_DETAILS,
  UPDATE_HEADER_OPTIONS,
  UPDATE_USER_INACTIVITY,
  UPDATE_TIMELINE_SPINNER_STATE,
  UPDATE_GO_BACK,
} from './action';

export const reducer = (state: State, action: StoreAction): State => {
  switch (action.type) {
    case SET_BASIC_DETAILS:
      return { ...state, ...action.payload };

    case UPDATE_HEADER_OPTIONS:
      return { ...state, headerOptions: action.payload };

    case UPDATE_USER_INACTIVITY:
      return { ...state, isUserInactive: action.payload };

    case UPDATE_TIMELINE_SPINNER_STATE: {
      return { ...state, timeLineSpinner: action.payload };
    }

    case UPDATE_GO_BACK: {
      return { ...state, goBack: action.payload };
    }

    default:
      return state;
  }
};
